module.exports = "/_next/static/images/e553bf90bb96ceb5b7a1a9dfad249b34-nucommunity-lg@1x.jpg.webp";